import { Button } from '@mantine/core';
import { IconFileSpreadsheet } from '@tabler/icons-react';

import { Id } from '@feature/utils';
import { ValidationStatus } from '@feature/validation';

interface ModelReportButtonProps {
  year: number;
  validationStatus: ValidationStatus | null;
  userId: Id | null;
  filterAfterAffiliation: boolean;
}

const onDownload = (
  year: number,
  validationStatus: ValidationStatus | null,
  userId: Id | null,
  filterAfterAffiliation: boolean,
) => {
  const userQuery = userId != null ? `&userId=${userId}` : '';
  const validationQuery = validationStatus != null ? `&validationStatus=${validationStatus}` : '';
  const filterAfterAffiliationQuery = `&filterAfterAffiliation=${filterAfterAffiliation}`;

  window.open(
    `/api/annual-report/generate/model-report/${year}?${userQuery}${validationQuery}${filterAfterAffiliationQuery}`,
  );
};

export function ModelReportButton({ year, validationStatus, userId, filterAfterAffiliation }: ModelReportButtonProps) {
  return (
    <Button
      size="xs"
      leftSection={<IconFileSpreadsheet size="24px" />}
      onClick={() => onDownload(year, validationStatus, userId, filterAfterAffiliation)}
    >
      Descarcă date conform modelului de raportare
    </Button>
  );
}
